import React from 'react';
import { ChevronDown } from 'lucide-react';

const dropdownOptions = [
  'Physical Disability',
  'Visual Impairment',
  'Hearing Impairment',
  'Intellectual Disability',
  'Other',
];

const languages = [
  'Disability',
  'Type of Disability',
  'Economic Recovery',
  'SMMEs Development',
  'Rural Development',
  'Access to Markets',
  'Innovation',
  'Non',
];

const GroupExperience = ({
  selected = [],
  setSelected,
  selectedType,
  setSelectedType,
  onSave
}) => {
  const [showDropdown, setShowDropdown] = React.useState(false);

  const handleSelect = (lang) => {
    if (lang === 'Type of Disability') {
      setShowDropdown(!showDropdown);
    } else {
      setSelected(prev =>
        prev.includes(lang) ? prev.filter(item => item !== lang) : [...prev, lang]
      );
    }
  };

  const handleDropdownOption = (option) => {
    setSelectedType(option);
    setShowDropdown(false);
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        SECTIOND: "AREAS OF FOCUS", // set as needed
        typeOfFocus: "Areas of Focus",
        selectedAreas: selected,
        selectedDisabilityType: selectedType,
      });
    }
  };

  return (
    <div className='md:mt-2'>
      <div className='md:mt-1 mt-3'>
        <div className="flex items-center justify-between">
          <h1 className='md:text-[36px] text-[10px] font-bold text-center mx-auto w-full'>
            SECTION D: AREAS OF FOCUS
          </h1>
          <img 
            src='https://res.cloudinary.com/dzngpgki4/image/upload/v1746297211/Expand_down_18_nrspje.png' 
            alt='icon' 
            className='md:w-[38px] md:h-[38px] w-[14px] h-[14px]'
          />
        </div>
        <p className='md:text-[24px]  text-center   text-[6px] font-light italic'>
          Does your activities respond to the following
        </p>
      </div>
      <div className="grid grid-cols-2 md:gap-2 gap-1 md:mt-6 mt-2 relative">
        {languages.map((lang, i) => {
          const isActive = selected.includes(lang);
          const isDropdown = lang === 'Type of Disability';
          return (
            <div key={i} className="relative">
              <button
                onClick={() => handleSelect(lang)}
                className={`flex items-center justify-between w-full md:h-[70px] h-[20px] text-left rounded-[5px] md:px-4 px-2 ${
                  isDropdown ? 'bg-[#D9D9D9]' : 'bg-[#E7EBEB]'
                }`}
              >
                <span className="font-medium text-[4px] md:text-[24px] leading-[1.10] md:w-[500px]">
                  {isDropdown && selectedType ? selectedType : lang}
                </span>
                {isDropdown ? (
                  <ChevronDown className="w-3 h-3 md:w-8 md:h-8 " />
                ) : (
                  <span
                    className={`md:w-14 md:h-14 w-3 h-3 rounded-full ${
                      isActive
                        ? 'bg-[#03897B] md:border-[8px] border-[3px] border-white'
                        : 'md:border-[8px] border-[3px] border-white bg-[#D9D9D9]'
                    }`}
                  />
                )}
              </button>
              {isDropdown && showDropdown && (
                <div className="absolute z-10 left-0 right-0 bg-white shadow-md rounded-md mt-1">
                  {dropdownOptions.map((option, idx) => (
                    <div
                      key={idx}
                      onClick={() => handleDropdownOption(option)}
                      className="px-4 py-2 text-[6px] md:text-[18px] hover:bg-[#E7EBEB] cursor-pointer"
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="md:h-20 h-4" />
    </div>
  );
};

export default GroupExperience;